import * as React from "react";
import { Button } from "@uikit";
import Calendar from "@uikit/calendar";
import { useApp } from "@store/app";

interface IProps {
  value?: string;
  onChange?: (e: string) => void;
  onClose?: () => void;
}

const DatePicker = ({ value, onClose, onChange }: IProps) => {
  const hideModals = useApp(($) => $.hideModals);

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-40 z-[999] flex items-end sm:items-center justify-center`}
      onClick={(e) => {
        if (e.target !== e.currentTarget) return;
        if (onClose) {
          onClose();
        } else {
          hideModals();
        }
      }}
    >
      <div className="flex justify-center flex-1 sm:flex-none">
        <div
          className={`bg-white rounded-t-lg  drop-shadow-modal sm:rounded-lg 
         p-4  sm:p-9 w-full transition-all ease-in-out min-w-[100%] sm:min-w-[500px] lg:min-w-[500px]`}
        >
          <div className="sm:mb-4 sm:min-w-[482px]">
            <Calendar monthsToShow={1} value={value} onChange={onChange} />
          </div>
          {!onChange && (
            <Button
              onClick={() => {
                if (onClose) {
                  onClose();
                } else {
                  hideModals();
                }
              }}
              size="large"
              color="green"
              width="full"
              className={`my-1 mb-0`}
              text="Done"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default DatePicker;
